document.addEventListener("DOMContentLoaded", function () {
    // Haal de 'packs-calculator' div op en krijg de waarde van 'data-mtwo'
    var packsCalculator = document.querySelector(".packs-calculator");
    var mtwoPerPack = parseFloat(packsCalculator.getAttribute("data-mtwo").replace(',', '.'));

    // Haal de input-elementen en andere benodigde elementen op
    var mtwoInput = document.getElementById("mtwo");
    var packsInput = document.getElementById("packs");
    var totalPriceElement = document.querySelector(".total-price");
    var totalPricePriceElement = document.querySelector(".total-price-price");
    var perM2Element = document.querySelector(".per-m2");
    var packPrice = parseFloat(packsCalculator.getAttribute("data-unitprice").replace(',', '.'))
    const priceRegular = document.querySelector('.price__regular');

    // Bereken de prijs per m2 en werk de UI bij
    var pricePerM2 = (packPrice / mtwoPerPack).toFixed(2);
    
    if ((window.location.pathname).includes('pvc-vloeren')) {
      // Old + New price (per pack)
      const productInfoParent = document.querySelector('product-info');
      const oldPrice = parseFloat((productInfoParent.querySelector('.price').dataset.oldPrice).replace(',', '.'));
      const newPrice = parseFloat((productInfoParent.querySelector('.price').dataset.newPrice).replace(',', '.'));
      const oldPricePerM2Element = productInfoParent.querySelector('.price__sale');
      
      // Calculate discount per pack
      if (oldPricePerM2Element) {
        const percentageDiscount = Math.abs(((newPrice - oldPrice) / oldPrice * 100))
        const oldPricePerM2 = parseFloat(pricePerM2 * 100 / (100 - percentageDiscount)).toFixed(2);
        
        // Set prices
        oldPricePerM2Element.innerHTML = '€' + oldPricePerM2.replace('.', ',');
      }

      priceRegular.innerHTML = '€' + pricePerM2.replace('.', ',');
    }

    if (perM2Element) {
        perM2Element.innerHTML = '€' + pricePerM2.replace('.', ',');
    }
    if (totalPricePriceElement) {
        totalPricePriceElement.innerHTML = '€' + packPrice.toFixed(2).replace('.', ',');
    }


    // Functie om de totale prijs bij te werken
    function updateTotalPrice(value, isMtwoInput) {
        var packValue, totalPrice;

        if (isMtwoInput) {
            packValue = Math.ceil(value / mtwoPerPack);
            packsInput.value = packValue;
        } else {
            packValue = value;
            mtwoInput.value = (packValue * mtwoPerPack).toFixed(2);
        }

        totalPrice = packPrice * packValue;

        if (value === "" || isNaN(value)) {
            totalPriceElement.innerHTML = `<div class="no-price">Voer hierboven uw gewenste hoeveelheid in.</div>`;
        } else {
            totalPriceElement.innerHTML = `<span class="calc-title">Totale prijs: </span><span class="total-amount">€${totalPrice.toFixed(2).replace('.', ',')}</span>`;
        }

        // Werk het formulier bij met het juiste aantal
        var quantityInput = document.querySelector('quantity-input input[name="quantity"]');
        if (quantityInput) {
            quantityInput.value = packValue || 1;
        }
    }

    // Voeg event listeners toe aan de inputs
    mtwoInput.addEventListener("input", function () {
        var value = parseFloat(mtwoInput.value);
        updateTotalPrice(value, true);
    });

    packsInput.addEventListener("input", function () {
        var value = parseFloat(packsInput.value);
        updateTotalPrice(value, false);
    });
});